'use strict';

function CompanyGroupCategoryService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/group-category/:categoryId', {categoryId: "@id"}, {
    'update': { method: 'PUT' },
    'delete': { method: 'DELETE'}
  });
}

angular.module('dokiv')
  .factory('CompanyGroupCategoryService', ['$resource', 'config', CompanyGroupCategoryService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/groups/CompanyGroupCategoryService.js
// module id = 60
// module chunks = 0